import { render, staticRenderFns } from "./LandingContacts.vue?vue&type=template&id=2d43a2ad"
import script from "./LandingContacts.vue?vue&type=script&lang=js"
export * from "./LandingContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports